export const showLogger = false;

export const logger = (prefix: string) => (store: any) => (next: (arg0: any) => any) => (action: any) => {
  const r = next(action);
  console.log(prefix, '\n', r, '\n', store.getState());
  return r;
};
